module.exports = __webpack_public_path__ + "img/ABSNSE-Log-dark.901f061f.svg";